<script setup lang="ts"></script>

<template>
    <h1>Необходима авторизация</h1>
</template>

<style scoped></style>
